import { LOCATION_CHANGED } from '../ducks/routing.duck';

// Create a Redux middleware from the given analytics handlers. Each
// handler should have the following methods:
//
// - trackEvent(url, store, routeName, { initialPageLoad, location }): called when the URL is changed
//
// Handlers run after the reducers, so the routing state they read belongs to
// the tracked page: routing.previousLocation is the page the user just left.
export const createMiddleware = (handlers) => (store) => (next) => (action) => {
  next(action);

  const { type, payload } = action;
  if (type === LOCATION_CHANGED) {
    const { canonicalUrl, routeName, initialPageLoad, location } = payload;
    handlers.forEach((handler) => {
      handler.trackEvent(canonicalUrl, store, routeName, { initialPageLoad, location });
    });
  }
};
